var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvalanche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12048_19257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#E84142"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5177 22.75H8.48966C7.85366 22.75 7.53966 22.75 7.34766 22.627C7.2465 22.561 7.16229 22.4721 7.10184 22.3675C7.04139 22.263 7.00638 22.1456 6.99966 22.025C6.98766 21.799 7.14466 21.522 7.45966 20.97L14.9317 7.77702C15.2497 7.21702 15.4117 6.93702 15.6137 6.83302C15.7218 6.77805 15.8414 6.74939 15.9627 6.74939C16.084 6.74939 16.2035 6.77805 16.3117 6.83302C16.5147 6.93702 16.6757 7.21702 16.9937 7.77702L18.5297 10.463L18.5377 10.477C18.8807 11.077 19.0547 11.383 19.1307 11.703C19.2157 12.0533 19.2157 12.4188 19.1307 12.769C19.0547 13.092 18.8817 13.399 18.5337 14.009L14.6077 20.959L14.5977 20.976C14.2517 21.582 14.0777 21.889 13.8337 22.121C13.5711 22.3725 13.2522 22.5576 12.9037 22.661C12.5847 22.75 12.2297 22.75 11.5177 22.75ZM19.1607 22.75H23.4967C24.1367 22.75 24.4587 22.75 24.6507 22.624C24.7526 22.5576 24.8373 22.468 24.8978 22.3625C24.9583 22.2569 24.9929 22.1385 24.9987 22.017C25.0097 21.798 24.8567 21.533 24.5557 21.012L24.5237 20.958L22.3517 17.236L22.3267 17.194C22.0217 16.677 21.8667 16.416 21.6697 16.315C21.5624 16.2602 21.4436 16.2317 21.3232 16.2317C21.2027 16.2317 21.084 16.2602 20.9767 16.315C20.7767 16.419 20.6167 16.692 20.2987 17.24L18.1337 20.962L18.1267 20.975C17.8097 21.523 17.6507 21.796 17.6627 22.021C17.6693 22.1422 17.7043 22.2601 17.7647 22.3654C17.8251 22.4706 17.9094 22.5602 18.0107 22.627C18.1987 22.75 18.5207 22.75 19.1607 22.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12048_19257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalanche);
export default __webpack_public_path__ + "static/media/avalanche.27564ca72ddbeb3abb3f4b56bdf3db9c.svg";
export { ForwardRef as ReactComponent };